import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { current, logout } from "../Redux/Actions/AuthActions";
import { loadClient, logoutClient } from "../Redux/Actions/ClientActions";
import logo from "../image/LOGKDO+.png";
import "./NavAuth.css";

const NavAuth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // TOKENS & STATE
  const adminToken = localStorage.getItem("token");
  const clientToken = localStorage.getItem("clientToken");

  const adminState = useSelector((state) => state.AuthReducer);
  const clientState = useSelector((state) => state.clientAuth) || {};

  const adminUser = adminState?.user;
  const clientUser = clientState?.client;

  const isAdminAuthenticated = !!adminToken && !!adminUser;
  const isClientAuthenticated = !!clientToken && !!clientUser;

  useEffect(() => {
    if (adminToken && !adminUser) dispatch(current());
    if (clientToken && !clientUser) dispatch(loadClient());
  }, [dispatch, adminToken, clientToken, adminUser, clientUser]);

  const isAdmin = adminUser?.role === 'admin';

  const handleLogout = () => {
    if (isClientAuthenticated) {
      dispatch(logoutClient());
    } else if (isAdminAuthenticated) {
      dispatch(logout());
    }
    window.location.reload();
  };

  const clientPoints = clientState?.points || localStorage.getItem('clientPoints') || 0;

  // --- RENDERING HELPERS ---

  const ActionCard = ({ to, icon, title, desc, primary = false, gold = false, delay = "" }) => (
    <Link to={to} className={`action-card ${primary ? 'card-primary' : ''} ${gold ? 'card-gold' : ''} ${delay}`}>
      <div className="card-icon">{icon}</div>
      <div className="card-content">
        <div className="card-title">{title}</div>
        {desc && <div className="card-desc">{desc}</div>}
      </div>
    </Link>
  );

  return (
    <div className="dashboard-container">
      {/* HEADER */}
      <header className="dashboard-header">



        {/* LOGGED IN TOP ACTIONS */}
        {(isClientAuthenticated || isAdminAuthenticated) && (
          <div className="guest-header-actions animate-delay-1">
            <div className="circle-action-btn" style={{ background: 'var(--gradient-primary)', color: 'white', fontSize: '1rem', fontWeight: 'bold' }} data-tooltip={clientUser?.email || adminUser?.email}>
              {(clientUser?.name?.[0] || adminUser?.name?.[0] || "U").toUpperCase()}
            </div>
            <button onClick={handleLogout} className="circle-action-btn" style={{ background: '#fee2e2', color: '#ef4444', fontSize: '1.2rem' }} data-tooltip="Déconnexion">
              ⏻
            </button>
          </div>
        )}

        <img src={logo} alt="MKdo Logo" className="brand-logo" />
        <h1 className="welcome-text">Bienvenue</h1>
        <p className="sub-text">
          {isClientAuthenticated ? `Bonjour, ${clientUser?.name}` :
            isAdminAuthenticated ? `Administration - ${adminUser?.name}` :
              "Votre espace fidélité premium"}
        </p>
      </header>

      {/* ACTION GRID */}
      <div className="action-grid">

        {/* -- CLIENT VIEW -- */}
        {isClientAuthenticated && (
          <>
            <ActionCard
              to="/scan-points"
              icon="📷"
              title="Scanner QR"
              desc="Cumulez vos points"
              primary
              delay="animate-delay-1"
            />
            <ActionCard
              to="/my-points"
              icon="🎁"
              title="Mes Points"
              desc={`${clientPoints} pts disponibles`}
              gold
              delay="animate-delay-2"
            />
            <ActionCard
              to="/rewards"
              icon="🏆"
              title="Récompenses"
              desc="Voir le catalogue"
              delay="animate-delay-3"
            />
            <ActionCard
              to="/history"
              icon="📊"
              title="Historique"
              desc="Vos transactions"
              delay="animate-delay-3"
            />
            <ActionCard
              to="/profile"
              icon="👤"
              title="Mon Profil"
              desc="Gérer mon compte"
              delay="animate-delay-4"
            />
          </>
        )}

        {/* -- ADMIN VIEW -- */}
        {isAdminAuthenticated && (
          <>
            <ActionCard
              to="/manage-rewards"
              icon="🎁"
              title="Gérer KDO"
              desc="Catalogue des offres"
              primary
              delay="animate-delay-1"
            />
            <ActionCard
              to="/manage-offers"
              icon="⭐"
              title="À la une"
              desc="Gérer le contenu vedette"
              primary
              delay="animate-delay-1"
            />
            <ActionCard
              to="/qr-scanner-admin"
              icon="📱"
              title="Scanner"
              desc="Valider des points"
              gold
              delay="animate-delay-2"
            />
            <ActionCard
              to="/Register"
              icon="➕"
              title="Nouvel Utilisateur"
              desc="Créer un compte"
              delay="animate-delay-3"
            />
            <ActionCard
              to="/AllUser"
              icon="👥"
              title="Utilisateurs"
              desc="Liste complète"
              delay="animate-delay-3"
            />
            <ActionCard
              to="/points-report"
              icon="📈"
              title="Rapports"
              desc="Statistiques points"
              delay="animate-delay-4"
            />
            <ActionCard
              to="/UpdateProfil"
              icon="⚙️"
              title="Configuration"
              desc="Paramètres admin"
              delay="animate-delay-4"
            />
          </>
        )}

        {/* -- GUEST VIEW -- */}
        {/* -- GUEST VIEW -- */}
        {(!isClientAuthenticated && !isAdminAuthenticated) && (
          <>
            <ActionCard
              to="/login-client"
              icon="👤"
              title="Espace Client"
              desc="Accéder à vos points"
              primary
              delay="animate-delay-1"
            />
            <ActionCard
              to="/Login"
              icon="🔒"
              title="Administration"
              desc="Réservé au staff"
              delay="animate-delay-2"
            />
            <ActionCard
              to="/register-client"
              icon="✨"
              title="Inscription"
              desc="Créer un compte client"
              gold
              delay="animate-delay-3"
            />
          </>
        )}

      </div>

      {/* FOOTER REMOVED - MOVED TO HEADER */}
    </div>
  );
};

export default NavAuth;